var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:_vm.computedClass,attrs:{"data-cy":_vm.dataCy,"name":_vm.name},on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }